module.exports = __webpack_public_path__ + "img/guide_account.257d1f1a.svg";